export default __webpack_public_path__ + "static/media/Rookwarden's Chestguard.0ebb79c2.jpg";